import { DropdownOption } from '@/common/getDropdownList';
import { Form } from '@/components/forms';
import Select from '@/components/forms/Select';
import { Translation } from '@/hoslog-intl';
import { UseFormReturn } from 'react-hook-form';

export type ManageReferralValidityFormValues = {
  affiliateToCustomer: string;
  affiliateToAffiliate: string;
  customerToCustomer: string;
};
export const ManageReferralValidityView = ({
  form,
  onSubmit,
  options,
}: {
  form: UseFormReturn<ManageReferralValidityFormValues>;
  onSubmit: (value: ManageReferralValidityFormValues) => Promise<void>;
  options: DropdownOption[];
}) => {
  return (
    <Form form={form} onSubmit={onSubmit}>
      <div className="w-full py-3 px-6 bg-warning my-4 text-[13px] font-medium leading-normal text-on-color">
        <Translation id="pointManagement.pointsConfiguration.customer.referralValidityForm.noticeMessage" />
      </div>
      <div className="flex w-full flex-col gap-[10px] px-6 pb-8">
        <Select
          label="pointManagement.pointsConfiguration.customer.referralValidityForm.affiliateToCustomer"
          {...form.register('affiliateToCustomer')}
          options={options}
          disabled
        />
        <Select
          label="pointManagement.pointsConfiguration.customer.referralValidityForm.affiliateToAffiliate"
          {...form.register('affiliateToAffiliate')}
          options={options}
          disabled
        />
        <Select
          label="pointManagement.pointsConfiguration.customer.referralValidityForm.customerToCustomer"
          {...form.register('customerToCustomer')}
          options={options}
          disabled
        />
      </div>
    </Form>
  );
};
